import { MINUTE } from 'shared/constants';

export const VERIFICATION_TIMEOUT = MINUTE;
